import { render, staticRenderFns } from "./TwoFaResetCodeConfirmCopy.vue?vue&type=template&id=42ff9f13&"
import script from "./TwoFaResetCodeConfirmCopy.vue?vue&type=script&lang=js&"
export * from "./TwoFaResetCodeConfirmCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports